<template>

  <transition name='fade'>

    <div class='mediaGallery' v-if='this.$props.show' @keyup.ctrl.tab='handleTabChange'>

      <transition name='fade'>
        <div class='mediaGallery__progress' v-if='loadingPage'>
          <v-progress-circular
            :size='70'
            :width='7'
            indeterminate
            color='primary'
            class='center-block'
          ></v-progress-circular>
        </div>
      </transition>

      <v-chip class='nav__pages white--text'>{{ parseInt($route.params.pageNumber) + 1 }} / {{ $props.pages }}</v-chip>

      <v-btn fab dark small flat class='nav__close' @click.prevent="$emit('close')">
        <v-icon dark>close</v-icon>
      </v-btn>

      <v-btn
        fab
        dark
        small
        flat
        @click.prevent='prev'
        v-bind:class="{'nav__prev': !isRTL, 'nav__next': isRTL}"
        v-if='parseInt($route.params.pageNumber) > 0'
      >
        <v-icon>{{ isRTL ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}</v-icon>
      </v-btn>

      <v-btn
        fab
        dark
        small
        flat
        @click.prevent='handleShowWhenFinish'
        v-bind:class="{'nav__prev': isRTL, 'nav__next': !isRTL}"
        v-if='showButtonArrowWhenFinish && !showWhenFinish'
      >
        <v-icon>{{ isRTL ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}</v-icon>
      </v-btn>

      <v-btn
        fab
        dark
        small
        flat
        @click.prevent='next'
        :class="{'nav__next': !isRTL, 'nav__prev': isRTL}"
        v-if='parseInt($route.params.pageNumber)+1 < $props.pages'
      >
        <v-icon>{{ isRTL ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}</v-icon>
      </v-btn>

      <v-flex class='mediaGallery__footer text-center'>
        <v-btn
          v-if='isFullScreenEnable'
          @click.prevent='onFullScreen()'
          v-bind:class="{
					active: $props.fullscreen,
					'super-comics-viewer-icons' :true
				}"
        >
          <v-icon>fullscreen</v-icon>
        </v-btn>

        <v-btn @click.prevent="$emit('superzoom')" class='super-comics-viewer-icons icon-supper-zoom'>
          <img v-if='superZoom' src='../assets/img/SuperZoom.svg'>
          <img v-else src='../assets/img/SuperZoomInactive.svg'>
        </v-btn>

        <v-btn @click.prevent='openThumbs()' class='super-comics-viewer-icons'>
          <img src='../assets/img/pages.svg'>
        </v-btn>

        <!-- <v-btn @click.prevent="$emit('close')"
          nav__close
          v-bind:class="{ active: $props.close, 'super-comics-viewer-icons' :true }">
            <v-icon>close</v-icon>
        </v-btn> -->
      </v-flex>

      <div class='mediaGallery__container'>
        <div class='zoom'>
          <div class='media' ref='imageWrap' v-if='!showWhenFinish'>
            <img
              :class='{
                media: true,
                rotateRight: this.rotateRight,
                rotateLeft: this.rotateLeft
              }'
              :src='this.$props.image'
              ref='image'
              alt=''
            >

            <transition name='fade'>
              <div
                class='mediaGallery__focus'
                ref='focus'
                v-show='this.$props.superZoom === true && this.panels.length > 0'
              ></div>
            </transition>
          </div>

          <div class='show-when-finish' v-if='showWhenFinish' @click.prevent='onClickWhenFinished'>
            {{ $props.issue.messageWhenFinished }}
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
import bus from '@/utils/bus';
import Hammer from 'hammerjs/hammer.min.js';
import * as Zoom from '@/plugins/ImageZoom.js';

export default {
  name: 'mediaGallery',
  props: {
    show: false,
    fullscreen: false,
    superZoom: false,
    image: '',
    data: {},
    pages: '',
    issue: {}
  },
  // mounted() {
  // this.panels = this.sortArray(this.panels, "order");
  // },
  data() {
    return {
      listenerKeyup: false,
      index: 0,
      panels: [],
      naturalWidth: this.$props.data.width,
      naturalHeight: this.$props.data.height,
      keyCode: '',
      loadingPage: true,
      direction: 'top',
      fab: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
      rotateRight: false,
      rotateLeft: false,
      showWhenFinish: false
    };
  },
  computed: {
    isFullScreenEnable() {
      return (
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      );
    },
    isRTL() {
      return this.$func.getRTL();
    },
    showButtonArrowWhenFinish() {
      if (
        parseInt(this.$route.params.pageNumber) + 1 === this.$props.pages &&
        this.$props.issue.urlWhenFinished &&
        this.$props.issue.urlWhenFinished.length
      ) {
        return true;
      }

      return false;
    }
  },
  watch: {
    show: function(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.createPanel(0);
        }, 500);
      }
    },
    data: function(newVal) {
      this.loadingPage = true;

      let newImg = new Image();
      newImg.src = this.$props.image;
      newImg.onload = () => {
        this.loadingPage = false;

        if (this.$props.superZoom === false) {
          Zoom.resetZoom();
        } else {
          window.setTimeout(() => {
            this.createPanel(0);
          }, 100);
        }
      };
      this.panels = newVal.focusPanels;
      this.naturalHeight = newVal.height;
      this.naturalWidth = newVal.width;
    },
    superZoom: function(newVal) {
      //this.$props.superZoom = newVal

      setTimeout(() => {
        if (newVal && this.$refs.focus !== undefined) {
          this.createPanel(0);
        } else {
          Zoom.resetZoom();
        }
      }, 200);
    }
  },
  methods: {
    onClickWhenFinished() {
      if (!this.issue.urlWhenFinished) {
        return;
      }

      window.open(this.issue.urlWhenFinished, '_blank');
    },

    handleShowWhenFinish() {
      this.showWhenFinish = true;
    },

    sortArray(array, property, direction) {
      direction = direction || 1;
      array.sort(function compare(a, b) {
        let comparison = 0;
        if (a[property] > b[property]) {
          comparison = 1 * direction;
        } else if (a[property] < b[property]) {
          comparison = -1 * direction;
        }
        return comparison;
      });
      return array; // Chainable
    },
    initGestures() {
      var elementContainer = document.querySelector('.mediaGallery__container');
      var elementFooter = document.querySelector('.mediaGallery__footer');
      var hammerContainer = new Hammer(elementContainer);
      var hammerFooter = new Hammer(elementFooter);

      hammerContainer.on('swipeleft', e => {
        if (this.isReseted()) {
          this.next();
        }
      });

      hammerContainer.on('swiperight', e => {
        if (this.isReseted()) {
          this.prev();
        }
      });

      hammerFooter.on('swipeleft', e => this.next());
      hammerFooter.on('swiperight', e => this.prev());
    },
    isReseted() {
      return this.$refs.imageWrap.getAttribute('data-scale') === '1';
    },
    openThumbs() {
      bus.$emit('show-thumbs', true);
    },
    onFullScreen() {
      this.$emit('fullscreen');
      //this.resizeWindow()
      window.setTimeout(() => {
        this.createPanel(this.index);
      }, 100);
    },
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    handleGlobalKeyup(e) {
      if (this.$props.show) {
        this.keyCode = e.keyCode;
        if (e.keyCode === 39) {
          this.next();
        }
        if (e.keyCode === 37) {
          this.prev();
        }
      }
    },
    getNaturalSize(value1, value2, value3) {
      return (value1 * value2) / value3;
    },
    setCrop(dataCrop) {
      let image = {
        width: this.$refs.image.clientWidth,
        height: this.$refs.image.clientHeight
      };
      this.$refs.focus.style.width =
        this.getNaturalSize(dataCrop.width, image.width, this.naturalWidth) +
        'px';
      this.$refs.focus.style.height =
        this.getNaturalSize(dataCrop.height, image.height, this.naturalHeight) +
        'px';
      this.$refs.focus.style.left =
        this.getNaturalSize(dataCrop.left, image.width, this.naturalWidth) +
        'px';
      this.$refs.focus.style.top =
        this.getNaturalSize(dataCrop.top, image.height, this.naturalHeight) +
        'px';

      dataCrop.naturalWidth = this.naturalWidth;
      dataCrop.naturalHeight = this.naturalHeight;

      setTimeout(() => {
        this.resizeWindow();
        Zoom.zoomTo(dataCrop);
      }, 100);

      if (this.naturalWidth === 0) {
        bus.$emit('snackbar', 'Esta página não tem super zoom.', 'error', 3000);
        this.$emit('superzoom');
      }
    },
    prev() {
      if (this.showWhenFinish) {
        this.showWhenFinish = false;
        return;
      }

      if (parseInt(this.$route.params.pageNumber) === 0) {
        this.rotateRight = true;
        window.setTimeout(() => {
          this.rotateRight = false;
        }, 300);
        return;
      }

      if (this.showPrevButton === false) {
        return;
      }

      if (
        this.$props.superZoom === false ||
        this.index === 0 ||
        this.panels.length === 0
      ) {
        this.$emit('prevPage');
        return;
      }

      this.prevPanel();
    },
    next() {
      if (this.showWhenFinish) {
        this.showWhenFinish = false;
        return;
      }

      if (parseInt(this.$route.params.pageNumber) + 1 === this.$props.pages) {
        this.rotateLeft = true;
        window.setTimeout(() => {
          this.rotateLeft = false;
        }, 300);
        return;
      }

      if (this.showNextButton === false) {
        return;
      } else if (
        this.$props.superZoom === false ||
        this.index === this.panels.length - 1 ||
        this.panels.length === 0
      ) {
        this.$emit('nextPage');
      } else {
        this.nextPanel();
      }
    },
    prevPanel() {
      if (this.index > 0) {
        this.index--;
      } else {
        this.index = this.panels.length - 1;
      }
      this.createPanel();
    },
    nextPanel() {
      if (this.index < this.panels.length - 1) {
        this.index++;
      } else {
        this.index = 0;
      }
      this.createPanel();
    },
    createPanel(index) {
      this.panels = this.sortArray(this.panels, 'order');

      this.loadingPage = false;

      if (index !== undefined) {
        this.index = index;
      }

      if (this.panels.length === 0 || this.$props.superZoom === false) {
        return;
      }

      /* this.panels.forEach( (item, i) => {
       if(this.index !== i){
       this.$set(this.panels[i], 'active', false)
       }
       }) */
      //this.$set(this.panels[this.index], 'active', true)

      let coordenades = {
        left: this.panels[this.index].x,
        top: this.panels[this.index].y,
        width: this.panels[this.index].width,
        height: this.panels[this.index].height
      };
      this.setCrop(coordenades);
    },
    mountPage() {
      //this.initGestures()
      Zoom.zoom();
    },
    resizeWindow(e) {
      try {
        var imageWrap = this.$refs.imageWrap;
        var image = this.$refs.image;
        var left = (imageWrap.offsetWidth - image.offsetWidth) / 2;
        var top = (imageWrap.offsetHeight - image.offsetHeight) / 2;
        this.$refs.focus.style.transform =
          'translateX(' + left + 'px) translateY(' + top + 'px)';
      } catch (exc) {}
    }
  },
  mounted: function() {
    let self = this;

    window.setTimeout(() => {
      this.mountPage();
      //this.resizeWindow()
      window.addEventListener('resize', this.resizeWindow);
      window.addEventListener('wheel', this.resizeWindow);
    }, 500);

    if (!this.listenerKeyup) {
      this.listenerKeyup = true;
      window.addEventListener('keyup', function(e) {
        self.handleGlobalKeyup(e);
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.show-when-finish {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%) !important;
  padding: 2rem;
  max-width: 80%;
  cursor: pointer;
  font-size: 26px;
  text-align: center;
  text-decoration: underline;
}
</style>
